import axios from "axios";
import { useRecoilValue } from "recoil";
import { useMemo, createContext } from "react";
import authAtom from "../atoms/auth/auth.atom";
import { message } from "antd";

const { href: host } = window.location;
export const AxiosContext = createContext(null);
export const isTestEnv = host.includes("localhost") || host.includes("surge");
const isDevEnv =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development" || isTestEnv;
  
export const baseURL = isDevEnv
  ? "https://api.verivault.net/api/v1"
  : "https://api.verivault.net/api/v1";
export default function AxiosContextProvider({ children }) {
  const { isLoggedIn, user } = useRecoilValue(authAtom);
  const axiosInstance = useMemo(() => {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    if (isLoggedIn) {
      headers.Authorization = `Bearer ${user?.token}`;
    }
    return axios.create({ baseURL, headers });
  }, [isLoggedIn, user]);

  axiosInstance.interceptors.response.use(
    (response) =>
      new Promise((resolve, reject) => {
        resolve(response);
      }),
    (error) => {
      if (!error.response) {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }
      if (
        error.response.status === 401 &&
        window.location.pathname !== "/auth/login" &&       
        message.error({
          content: 'Token has expired, please re-login to continue.',
          duration: 4,
          key: 'updatable',
        })
      ) {
        window.location.href = "/auth/login";      
        message.error({
          content: 'Token has expired, please re-login to continue.',
          duration: 4,
          key: 'updatable',
        })
      } else {
        return new Promise((resolve, reject) => {
          reject(error);
        });
      }
    }
  );


  return (
    <AxiosContext.Provider value={axiosInstance}>
      {children}
    </AxiosContext.Provider>
  );
}
